import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import { Watch } from "vue-property-decorator";
import {BaseOperationPropertyVue} from "fs-pb-vue2/vueModels/operations/properies/BaseOperationPropertyVue";
import { sumFilter } from "fs-pb-vue2/filters";

/**Модель представления реквизита операции */
export class BaseOperationPropertyVueFS extends BaseOperationPropertyVue {
  @Watch('property.Value', { immediate: true })
  valueChanged(val: any): void {
    if (this.property.Declaration.Type === DeclarationPropertiesTypes.Decimal) {
      this.sizeToPrecision();
    }
  }

  @Watch('currencyForSum')
  newCurrency(val: string): void {
    this.sumInpKey++;
  }
  
  @Watch('property.PhoneRightValue', { immediate: true })
  rightChanged(val: string): void {
    if (this.phoneWithOutCode !== val)
      this.phoneWithOutCode = val;
  }

  @Watch('phoneWithOutCode')
  maskedChanged(val: string): void {
    this.property.PhoneRightValue = val;
    this.property.PhoneDisplayValue = val;
  }

  @Watch('sumValue')
  sumChanged(val: number | null): void {
    if (val !== null)
      this.property.SumValue = sumFilter(val, false, this.property.CurrensySymbol);
  }

  phoneWithOutCode: string = '';

  sumInpKey: number = 0;

  sumValue: number | null = null;

  phoneBlur(): void {    
    this.$refs[this.property.Declaration.Name].focus();
    this.$refs[this.property.Declaration.Name].blur();
    //await this.onBlur();
  }

  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

  get currencyForSum(): string {
    let res = '';
    switch (this.currency) {
      case "₽":
        res = "RUB";
        break;
      case "$":
        res = "USD";
        break;
      case "€":
        res = "EUR";
        break;
      case "￥":
        res = "JPY";
        break;
      case "₣":
        res = "CHF";
        break;
      default:
        res = 'RUB';
        break;
    }
    return res;
  }

  sizeToPrecision(): void {
    if (this.property.Declaration.Type === DeclarationPropertiesTypes.Decimal && this.property.Value.length) {
      const stringValue: string = this.property.Value.toString().replaceAll('.', ',');
      const decimalPart: number = stringValue.indexOf(',') !== -1 ? stringValue.length - (stringValue.indexOf(',') + 1) : 0;
      if (decimalPart < this.property.Declaration.Size) {
        if (decimalPart === 0) {
          this.property.Value = new Number(this.property.Value).toFixed(this.property.Declaration.Size);
        } else {
          for (let i = 0; i < this.property.Declaration.Size - decimalPart; i++) {
            this.property.Value += '0';
          }
        }
      }
    }
  }
  
}
